import React from 'react';
import ProductView from '../ProductHeaderViewMobile';
import main from '../../resource/middleware_mobile/main.png';

const MainMobile = () => {
    return (
        <ProductView
            title="Middleware"
            description="Centralizamos las comunicaciones con los analizadores o sistemas en un servicio único compatible con SO Windows y Linux. Proveemos una página web para monitoreo y configuración de la herramienta."
            image={main} />
    );
};

export default MainMobile;